import isNil from 'lodash/isNil';
import isArray from 'lodash/isArray';
import currency from 'currency.js';
import { shouldApplyItemFeeByServiceType } from './shouldApplyItemFeeByServiceType';

const findCheapestVariation = (variations: []) => {
  const sortedVariations = variations.sort((a, b) => a.price - b.price);
  return sortedVariations[0];
};

export const itemTotalPrice = (item, isTakeAway: boolean, displayCheapestFromPrice: boolean = false) => {
  if (item.isFee && !shouldApplyItemFeeByServiceType(item, isTakeAway)) {
    return 0;
  }
  const customizationsPrice = item.customizations.reduce((acc, { type, current, variations }) => {
    let price;

    if (isNil(current)) {
      price = 0;
    } else if (type === 'checkbox-group' && isArray(current)) {
      const selectedVariations = variations.filter(({ step }) => current && current.includes(step));

      price = selectedVariations.reduce((acc, { price }) => acc.add(price), currency(0));
    } else {
      const variation = displayCheapestFromPrice
        ? findCheapestVariation(variations)
        : variations.find(({ step }) => current === step);

      price = variation
        ? !isTakeAway && variation.hasEatInPrice ? variation.priceEatIn : variation.price
        : 0;
    }

    return acc.add(price);
  }, currency(0));

  const itemPrice = item.hasEatInPrice && !isTakeAway ? item.priceEatIn : item.price;

  const dealOverridePriceDiff = item.dealPriceOverrideDiff
    ? isTakeAway
      ? item.dealPriceOverrideDiff.price
      : item.dealPriceOverrideDiff.priceEatIn
    : 0;

  return currency(itemPrice).add(customizationsPrice).add(dealOverridePriceDiff).value;
};
